import { ClaimAction } from "./types";

export const submitClaim = (payload) =>
  ({
    type: ClaimAction.SUBMIT_CLAIM,
    payload,
  } as const);

export const cleanUpClaimInfo = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  } as const);
